module.exports = (__parcel__import__("26TJ1")).then(() => parcelRequire('lmhgI'));